import { applyMiddleware, createStore as baseCreateStore, compose } from 'redux';
import thunk from 'redux-thunk';

export const createReducer = (initialState, reducerMap) => (state = initialState, action) => {
  const handle = reducerMap[action.type];
  
  if (typeof handle === 'function') {
    return handle(state, action.payload);
  }

  return state;
};

export const createStore = (reducers, state = {}) => {
  // Enable Redux DevTools Extension if available
  const composeEnhancers =
    (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
  
  const store = baseCreateStore(
    reducers,
    state,
    composeEnhancers(applyMiddleware(thunk))
  );
  
  // Expose store to window for debugging (only in development)
  if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
    window.__REDUX_STORE__ = window.__REDUX_STORE__ || {};
    // Store reference by a unique key (you can customize this)
    const storeKey = `store_${Date.now()}`;
    window.__REDUX_STORE__[storeKey] = store;
    // Also keep the latest store accessible
    window.__REDUX_STORE__.latest = store;
  }
  
  return store;
};